import React from 'react';
import { Row, Col } from 'antd';
import logoiconsmall from "../../../../assets/img/logo-icon-small.png";
import logotextsmall from "../../../../assets/img/logo-text-small.png";
import { SVGParallelogram } from './SVGParallelogram';

const Highlights = ({ catalogDetails }) => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.titleContainer}>
          <SVGParallelogram skewAmount={42} style={styles.title}>
            HIGHLIGHTS
          </SVGParallelogram>
        </div>
        <div style={styles.logoContainer}>
          <img src={logoiconsmall} alt="Logo Icon" />
          <img src={logotextsmall} alt="Logo Text" />
        </div>
      </div>
      <div style={{ pageBreakBefore: "auto", paddingTop: "16px" }}>
        <div style={styles.grid}>
          <Row gutter={[16, 16]}>
            {catalogDetails?.map((item, index) => (
              <Col xs={24} md={12} key={index}>
                <div style={styles.item}>
                  <div style={styles.border}></div>
                  <div style={styles.content}>
                    <h3 style={styles.itemTitle}>{item.heading}</h3>
                    <p style={styles.description}>{item.highlite}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#ffffff',
    padding: '10px',
    margin: '0',
    fontFamily: 'Manrope, sans-serif',
    fontWeight: 500,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '12px',
    margin: '0',
    position: 'relative',
    overflow: 'hidden',
    height: '100px'
  },
  titleContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: "white",
    fontSize: "46px",
    margin: "0",
    backgroundColor: "#0C3C78",
    padding: "15px",
    position: "relative",
    zIndex: 2,
    fontFamily: 'Lexend, sans-serif',
    fontWeight: 700,
    letterSpacing: '0%'
  },
  titleShape: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    paddingRight: '40px'
  },
  logoIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: '#00bcd4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '3px solid white'
  },
  logoC: {
    color: 'white',
    fontSize: '24px',
    fontWeight: 'bold'
  },
  logoText: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '1'
  },
  cenvance: {
    color: '#00bcd4',
    fontSize: '24px',
    fontWeight: 'bold',
    letterSpacing: '1px'
  },
  innovations: {
    color: '#00bcd4',
    fontSize: '14px',
    fontWeight: 'normal'
  },
  grid: {
    padding: '0',
    backgroundColor: '#ffffff'
  },
  item: {
    display: 'flex',
    backgroundColor: 'rgba(242, 242, 242, 1)',
    margin: '0',
    border: '1px solid #ddd',
    pageBreakInside: 'avoid',
    breakInside: 'avoid',
    paddingTop: 0,
    paddingBottom: 0,
  },
  border: {
    width: '6px',
    backgroundColor: '#00bcd4',
    flexShrink: 0,
    alignSelf: 'stretch',
  },
  content: {
    padding: '10px 15px',
    paddingLeft: 15,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  itemTitle: {
    color: '#0C3C78',
    fontSize: '26px',
    fontWeight: 'bold',
    margin: '0 0 12px 0',
    lineHeight: '1.3',
    paddingTop: '17px'
  },
  description: {
    color: '#5A667A',
    fontSize: '16px',
    lineHeight: '1.4',
    margin: '0',
    fontWeight: '400',
    paddingBottom: '17px'
  }
};

export default Highlights;